import { Injectable } from "@nestjs/common";
import { Cron } from "@nestjs/schedule";
import { AddressColumns, ColorColumns, CommonResponseModel, SizeColumns, SkechersCoLinereqModel, SkechersCoLineRequest, SkechersCoLineRequestApi, SkechersColorModel, SkechersCompareModelReq, SkechersDestinationModel, SkechersItemNoDtoReq, SkechersOrderDataModel, SkechersPoOrderFilter, SkechersSizeModel, SkechersSizeWiseModel, StatusEnum, } from "@project-management-system/shared-models";
import axios from "axios";
import * as FormData from 'form-data';
import * as fs from 'fs';
import * as path from 'path';
import * as puppeteer from 'puppeteer';
import { Like } from "typeorm";
import { DataSource } from "typeorm/data-source/DataSource";
import * as XLSX from 'xlsx';
import { GenericTransactionManager } from "../../typeorm-transactions";
import { SkechersItemNoDtos } from "./dto/skechers-co-item.dto";
import { SKechersOrderDetailsReq } from "./dto/skechers-orders-details.dto";
import { skechersAddressEntity } from "./entity/skechers-address-entity";
import { SkechersCOLineEntity } from "./entity/skechers-co-line.entity";
import { skechersColorEntity } from "./entity/skechers-color-entity";
import { SkechersOrdersChildEntity } from "./entity/skechers-orders-child.entity";
import { SkechersOrdersEntity } from "./entity/skechers-orders.entity";
import { SkechersPdfInfoEntity } from "./entity/skechers-pdf.entity";
import { SkechersSizeEntity } from "./entity/skechers-size-entity";
import { AddressRepo } from "./repositories/address-repo";
import { ColorRepo } from "./repositories/color-repo";
import { SizeRepo } from "./repositories/size-repo";
import { SkechersCOLineRepository } from "./repositories/skechers-co-line.repo";
import { SkechersOrdersChildRepository } from "./repositories/skechers-orders-child.repo";
import { SkechersPdfRepository } from "./repositories/skechers-pdf-repo";
import { SkechersOrdersRepository } from "./repositories/skechers.repo";
import dayjs = require("dayjs");
const { Builder, Browser, By, Select, until } = require('selenium-webdriver');

@Injectable()
export class SkechersService {

  constructor(
    private skechersOrdersRepo: SkechersOrdersRepository,
    private skechersOrdersChildRepo: SkechersOrdersChildRepository,
    private dataSource: DataSource,
    private pdfRepo: SkechersPdfRepository,
    private skechersCoLineRepo: SkechersCOLineRepository,
    private addressRepo: AddressRepo,
    private colorRepo: ColorRepo,
    private sizeRepo: SizeRepo

  ) { }

  async fileUploadSkechers(files: Express.Multer.File[]): Promise<CommonResponseModel> {
    let extractedData: any;
    try {
      for (const file of files) {
        const formData = new FormData();
        const fileToUpload = file.buffer ? file.buffer : fs.readFileSync(file.path);
        const fileName = file.originalname;
        formData.append('file', fileToUpload, { filename: fileName });
        // const downloadUrl = 'http://192.168.1.100:2000/tables_data';
        const downloadUrl = 'http://165.22.220.143:2000/tables_data'
        const firstResponse = await axios.post(downloadUrl, formData, {
          headers: {
            ...formData.getHeaders(),
          },
          responseType: 'arraybuffer',
        });
        const data = new Uint8Array(firstResponse.data);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonSheet = XLSX.utils.sheet_to_json(sheet, { defval: null, raw: false });
        const extractedExcelData = jsonSheet.filter(row => Object.values(row).some(cell => cell !== null && cell !== ''));
        extractedData = extractedExcelData.flat()
      }
      return new CommonResponseModel(true, 1234, 'Data Extracted', extractedData);
    } catch (error) {
      console.error('Error during file upload and processing:', error);
      throw new Error('Failed to upload and process the files');
    }
  }

  async saveSkechersOrdersData(req: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    try {
      let saved;
      const pdfData = [];

      await transactionManager.startTransaction();

      for (const item of req.SkechersPoItemDetails) {
        for (const variant of item.SkecherspoItemVariantDetails) {
          const orderData = await this.skechersOrdersRepo.findOne({ where: { poNumber: req.poNumber, poStyle: item.poStyle, lineNo: variant.lineNo, size: variant.size } });
          const order = await this.skechersOrdersChildRepo.findOne({ where: { poNumber: req.poNumber, poStyle: item.poStyle, size: variant.size }, order: { poVersion: 'DESC' } })

          const entity = new SkechersOrdersEntity();
          entity.poNumber = req.poNumber

          entity.deliveryAddress = item.deliveryAddress
          entity.poStyle = item.poStyle

          entity.lineNo = variant.lineNo
          entity.exFactoryDate = variant.exFactoryDate
          entity.deliveryDate = variant.deliveryDate
          entity.itemType = variant.itemType
          entity.color = variant.color
          entity.size = variant.size
          entity.quantity = variant.quantity
          entity.status = StatusEnum.OPEN

          pdfData.push(entity);

          if (orderData) {
            const update = await transactionManager.getRepository(SkechersOrdersEntity).update(
              { poNumber: req.poNumber, poStyle: item.poStyle, lineNo: variant.lineNo, size: variant.size },
              {
                poStyle: item.poStyle,
                deliveryAddress: item.deliveryAddress,

                itemType: variant.itemType,
                exFactoryDate: variant.exFactoryDate,
                deliveryDate: variant.deliveryDate,
                color: variant.color,
                quantity: variant.quantity,
                status: StatusEnum.OPEN

              }
            );

            let po = parseInt(order?.poVersion) + 1
            const entitys = new SkechersOrdersChildEntity()
            entitys.poNumber = req.poNumber

            entitys.poStyle = item.poStyle
            entitys.deliveryAddress = item.deliveryAddress

            entitys.lineNo = variant.lineNo
            entitys.itemType = variant.itemType
            entitys.exFactoryDate = variant.exFactoryDate
            entitys.deliveryDate = variant.deliveryDate
            entitys.size = variant.size
            entitys.color = variant.color
            entitys.quantity = variant.quantity

            entitys.status = StatusEnum.OPEN

            entitys.poVersion = po.toString()
            entitys.orderId = orderData.id

            const savedChild = await transactionManager.getRepository(SkechersOrdersChildEntity).save(entitys)
            if (!update.affected) {
              throw new Error('Update failed');
            }
          }
          else {
            saved = await transactionManager.getRepository(SkechersOrdersEntity).save(entity);
            const entitys = new SkechersOrdersChildEntity()
            entitys.poNumber = req.poNumber

            entitys.poStyle = item.poStyle
            entitys.deliveryAddress = item.deliveryAddress

            entitys.lineNo = variant.lineNo
            entitys.itemType = variant.itemType
            entitys.exFactoryDate = variant.exFactoryDate
            entitys.deliveryDate = variant.deliveryDate
            entitys.size = variant.size
            entitys.color = variant.color
            entitys.quantity = variant.quantity

            entitys.status = StatusEnum.OPEN
            entitys.orderId = entity.id

            const savedChild = await await transactionManager.getRepository(SkechersOrdersChildEntity).save(entitys)
            if (!saved) {
              throw new Error('Save failed');
            }
          }
        }
      }

      await transactionManager.completeTransaction();
      return new CommonResponseModel(true, 1, 'Data saved successfully', saved);
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new CommonResponseModel(false, 0, 'Failed', err.message || 'Unknown error');
    }
  }

  async updatePath(req: any, jsonData: any, poNumber: any): Promise<CommonResponseModel> {
    try {
      let flag = true;
      const entities = []
      for (const res of req) {
        const entity = new SkechersPdfInfoEntity();
        entity.pdfFileName = res.filename
        entity.filePath = res.path
        entity.poNumber = poNumber
        entity.fileData = jsonData
        entity.fileType = res.mimetype.replace(/text\//g, "")
        entity.createdUser = "admin"
        entity.uploadStatus = "SUCCESS";
        entities.push(entity);
      }
      const uploadDoc = await this.pdfRepo.save(entities);
      if (!uploadDoc) {
        flag = false;
      }
      if (flag) {
        return new CommonResponseModel(true, 11, 'uploaded successfully', req);
      }
      else {
        return new CommonResponseModel(false, 11, 'uploaded failed', req);
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  async getPdfFileInfo(req?: any): Promise<CommonResponseModel> {
    try {
      const data = await this.pdfRepo.getPdfFileInfo(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'Data Rerived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, err)
    }
  }

  async getPoNumber(): Promise<CommonResponseModel> {
    try {
      const data = await this.skechersOrdersRepo.getDistinctPoNumbers()
      if (data) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async saveAddressInfo(formData: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionManager.startTransaction()
      const flag = new Set<boolean>()
      const columnArray = []
      const updatedArray = formData.map((obj) => {
        const updatedObj = {}
        for (const key in obj) {
          const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
          if (newKey != '') {
            columnArray.push(newKey);
            updatedObj[newKey] = obj[key];
          }
        }
        return updatedObj;
      })
      const difference = columnArray.filter((element) => !AddressColumns.includes(element));
      console.log(difference, '----')
      if (difference.length > 0) {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.")
      }
      const convertedData = updatedArray.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const value = obj[key];
          if (value === "") {
            updatedObj[key] = null;
          } else {
            updatedObj[key] = value;
          }
        }
        return updatedObj;
      });
      const deleteData = await transactionManager.getRepository(skechersAddressEntity).delete({})
      if (deleteData) {
        flag.add(true)
      } else {
        flag.add(false)
        return new CommonResponseModel(false, 0, 'Something wwent wrong in data deletion')
      }
      for (const data of convertedData) {
        if (data.destination != null) {
          const addObj = new skechersAddressEntity()
          addObj.destination = data.destination
          addObj.deliveryAddress = data.delivery_address
          addObj.buyerAddress = data.buyer_address
          addObj.buyerCode = data.buyer_code
          addObj.deliveryCode = data.delivery_code
          const addSave = await transactionManager.getRepository(skechersAddressEntity).save(addObj)
          if (addSave) {
            flag.add(true)
          } else {
            flag.add(false)
            await transactionManager.releaseTransaction();
            break;
          }
        } else {
          break
        }
      }
      if (!flag.has(false)) {
        await transactionManager.completeTransaction();
        return new CommonResponseModel(true, 1, 'Data saved successfully');
      } else {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 0, 'Something went wrong');
      }
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new CommonResponseModel(false, 0, 'Something went wrong');
    }
  }

  async getAddressInfo(): Promise<CommonResponseModel> {
    try {
      const info = await this.addressRepo.find()
      if (info) {
        return new CommonResponseModel(true, 1, 'Data retrieved', info)
      } else {
        return new CommonResponseModel(false, 0, 'No data found')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Something went wrong', err)
    }
  }

  async getAddressInfoByCountry(req: any): Promise<CommonResponseModel> {
    // console.log(req, "rtrtr")
    try {
      const countryWithoutSpaces = req.country.replace(/\s/g, '%');
      // console.log(countryWithoutSpaces, "countryWithoutSpaces")
      const info = await this.addressRepo.findOne({
        where: {
          deliveryAddress: Like(`%${countryWithoutSpaces}%`)
        }
      })
      // console.log(info,"idididid")
      if (info) {
        return new CommonResponseModel(true, 1, 'Data retrieved', info)
      } else {
        return new CommonResponseModel(false, 0, 'No data found')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Something went wrong', err)
    }
  }

  async saveColorInfo(formData: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionManager.startTransaction()
      const flag = new Set<boolean>()
      const columnArray = []
      const updatedArray = formData.map((obj) => {
        const updatedObj = {}
        for (const key in obj) {
          const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '').replace(/#/g, '');
          if (newKey != '') {
            columnArray.push(newKey);
            updatedObj[newKey] = obj[key];
          }
        }
        return updatedObj;
      })
      const difference = columnArray.filter((element) => !ColorColumns.includes(element));
      console.log(difference, "diff")
      if (difference.length > 0) {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.");
      }

      console.log(updatedArray, "pppppppppppp")

      const convertedData = updatedArray.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const value = obj[key];
          if (value === "") {
            updatedObj[key] = null;
          }
          // else if (key === 'CRMColorName' && value) {
          //   updatedObj[key] = value.toUpperCase();
          // }
          else {
            updatedObj[key] = value;
          }
        }
        return updatedObj;
      });
      const deleteData = await transactionManager.getRepository(skechersColorEntity).delete({})
      if (deleteData) {
        flag.add(true)
      } else {
        flag.add(false)
        return new CommonResponseModel(false, 0, 'Something went wrong in data deletion')
      }
      for (const data of convertedData) {
        if (data) {
          const addObj = new skechersColorEntity()
          addObj.itemNo = data.ItemNo
          addObj.poColorName = data.POColorName
          addObj.crmColorName = data.CRMColorName?.toUpperCase().trim()

          const addSave = await transactionManager.getRepository(skechersColorEntity).save(addObj)
          if (addSave) {
            flag.add(true)
          } else {
            flag.add(false)
            await transactionManager.releaseTransaction();
            break;
          }
        }
      }
      if (!flag.has(false)) {
        await transactionManager.completeTransaction();
        return new CommonResponseModel(true, 1, 'Data saved successfully');
      } else {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 0, 'Something went wrong');
      }
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new CommonResponseModel(false, 0, 'Something went wrong');
    }
  }

  async getColorInfo(): Promise<CommonResponseModel> {
    try {
      const info = await this.colorRepo.find()
      if (info) {
        return new CommonResponseModel(true, 1, 'Data retrieved', info)
      } else {
        return new CommonResponseModel(false, 0, 'No data found')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Something went wrong', err)
    }
  }

  async saveSizeInfo(formData: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionManager.startTransaction()
      const flag = new Set<boolean>()
      const columnArray = []
      const updatedArray = formData.map((obj) => {
        const updatedObj = {}
        for (const key in obj) {
          const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '').replace(/#/g, '');
          if (newKey != '') {
            columnArray.push(newKey);
            updatedObj[newKey] = obj[key];
          }
        }
        return updatedObj;
      })
      const difference = columnArray.filter((element) => !SizeColumns.includes(element));
      console.log(difference, "diff")
      if (difference.length > 0) {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.");
      }

      const convertedData = updatedArray.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const value = obj[key];
          if (value === "") {
            updatedObj[key] = null;
          } else {
            updatedObj[key] = value;
          }
        }
        return updatedObj;
      });
      const deleteData = await transactionManager.getRepository(SkechersSizeEntity).delete({})
      if (deleteData) {
        flag.add(true)
      } else {
        flag.add(false)
        return new CommonResponseModel(false, 0, 'Something went wrong in data deletion')
      }
      for (const data of convertedData) {
        console.log(data, "iiiiii")
        if (data) {
          const addObj = new SkechersSizeEntity()
          addObj.poSize = data.POSize
          addObj.crmSize = data.CRMSize?.toUpperCase().trim();
          const addSave = await transactionManager.getRepository(SkechersSizeEntity).save(addObj)
          if (addSave) {
            flag.add(true)
          } else {
            flag.add(false)
            await transactionManager.releaseTransaction();
            break;
          }
        }
      }
      if (!flag.has(false)) {
        await transactionManager.completeTransaction();
        return new CommonResponseModel(true, 1, 'Data saved successfully');
      } else {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 0, 'Something went wrong');
      }
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new CommonResponseModel(false, 0, 'Something went wrong');
    }
  }

  async getSizeInfo(): Promise<CommonResponseModel> {
    try {
      const info = await this.sizeRepo.find()
      if (info) {
        return new CommonResponseModel(true, 1, 'Data retrieved', info)
      } else {
        return new CommonResponseModel(false, 0, 'No data found')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Something went wrong', err)
    }
  }

  async getOrderComparsionData(req?: any): Promise<CommonResponseModel> {
    try {
      const Originaldata = await this.skechersOrdersRepo.getordercomparationData(req)
      const compareModel: SkechersCompareModelReq[] = []

      for (const rec of Originaldata) {
        const childData = await this.skechersOrdersChildRepo.find({
          where: {
            poNumber: rec.po_number, lineNo: rec.line_no, size: rec.size
          }, order: { ordersChildId: 'DESC' }, take: 1, skip: 1
        })
        if (childData.length > 0) {
          const oldData = childData[0];
          if (
            oldData.exFactoryDate !== rec.ex_factory_date ||
            oldData.quantity !== rec.quantity ||
            oldData.deliveryAddress !== rec.delivery_address
          ) {
            compareModel.push(new
              SkechersCompareModelReq(
                rec.po_number,
                rec.size,
                oldData.exFactoryDate,
                rec.ex_factory_date,
                Number(oldData.quantity),
                rec.quantity,
                oldData.deliveryAddress,
                rec.delivery_address
              ));
          }
        }
      }
      if (compareModel) {

        return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully', compareModel);
      } else {
        return new CommonResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      throw err
    }
  }

  async getSkechersOrderData(req?: SkechersPoOrderFilter): Promise<CommonResponseModel> {
    try {
      const details = await this.skechersOrdersRepo.getSkechersOrderDataRepo(req);
      console.log(details, "detuut")
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'No Data found');
      }
      const sizeDateMap = new Map<string, SkechersOrderDataModel>();
      for (const rec of details) {
        console.log(rec, "rececece")
        if (!sizeDateMap.has(`${rec.line_no},${rec.po_number}`)) {
          sizeDateMap.set(
            `${rec.line_no},${rec.po_number}`,
            new SkechersOrderDataModel(rec.id, rec.po_number, rec.po_style, rec.delivery_address, [], rec.size, rec.color, rec.ex_factory_date, rec.delivery_date, rec.quantity)
          );

        }
        const sizeWiseData = sizeDateMap.get(`${rec.line_no},${rec.po_number}`).sizeWiseData;
        console.log(sizeWiseData, "sizeWiseData")
        if (rec.size !== null) {
          sizeWiseData.push(new SkechersSizeWiseModel(rec.size, rec.color, rec.ex_factory_date, rec.delivery_date, rec.quantity));
        }
      }
      const dataModelArray: SkechersOrderDataModel[] = Array.from(sizeDateMap.values());
      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);
    } catch (e) {
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }

  async getSkechersOrderAcceptanceData(req?: SkechersPoOrderFilter): Promise<CommonResponseModel> {
    try {
      const details = await this.skechersOrdersRepo.getSkechersorderAcceptanceRepo(req);
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'No Data found');
      }
      const sizeDateMap = new Map<string, SkechersOrderDataModel>();
      for (const rec of details) {
        if (!sizeDateMap.has(`${rec.line_no},${rec.po_number}`)) {
          sizeDateMap.set(
            `${rec.line_no},${rec.po_number}`,
            new SkechersOrderDataModel(rec.id, rec.po_number, rec.po_style, rec.delivery_address, [], rec.size, rec.color, rec.ex_factory_date, rec.delivery_date, rec.quantity, rec.status)
          );

        }
        const sizeWiseData = sizeDateMap.get(`${rec.line_no},${rec.po_number}`).sizeWiseData;
        if (rec.size !== null) {
          sizeWiseData.push(new SkechersSizeWiseModel(rec.size, rec.color, rec.exFactory_date, rec.delivery_date, rec.quantity));
        }
      }
      const dataModelArray: SkechersOrderDataModel[] = Array.from(sizeDateMap.values());
      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);
    } catch (e) {
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }

  async skechersCoLineCreationReq(req: any): Promise<CommonResponseModel> {
    console.log(req, "rrrrrrrrrrrrr")
    try {
      if (req.itemNo == undefined || null) {
        return new CommonResponseModel(false, 0, 'Please enter Item No')
      };
      const records = await this.skechersOrdersRepo.find({ where: { poNumber: req.poNumber, deliveryDate: req.deliveryDate, poStyle: req.poStyle } });
      console.log(records, "recordsrecords")
      const uniqueColors = [...new Set(records.map((rec) => rec.color))];
      const empty = [];
      const entity = new SkechersCOLineEntity()
      entity.poNumber = req.poNumber;
      entity.exFactoryDate = req.exFactoryDate;
      entity.deliveryDate = req.deliveryDate;
      entity.poStyle = req.poStyle;
      entity.color = uniqueColors.join(',');
      entity.itemNo = req?.itemNo;
      entity.price = req?.price;
      entity.status = 'Open';
      entity.createdUser = req.createdUser;
      empty.push(entity)
      const save = await this.skechersCoLineRepo.save(empty);

      if (save) {
        const update = await this.skechersOrdersRepo.update(
          { poNumber: req.poNumber, deliveryDate: req.deliveryDate, poStyle: req.poStyle },
          { status: StatusEnum.INPROGRESS }
        );
        return new CommonResponseModel(true, 1, 'CO-Line request created successfully', save)
      } else {
        return new CommonResponseModel(false, 0, 'CO-Line request failed')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'CO-Line request failed', err)
    }
  }

  async getCoPoNumber(): Promise<CommonResponseModel> {
    const data = await this.skechersCoLineRepo.getCoPoNumber()
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getItem(): Promise<CommonResponseModel> {
    try {
      const data = await this.skechersCoLineRepo.getItem()
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async updateItemNo(req: SkechersItemNoDtoReq): Promise<CommonResponseModel> {
    try {
      const update = await this.skechersCoLineRepo.update(
        { id: Number(req.id) },
        { poNumber: req.poNumber, itemNo: req.itemNo, price: req.price }
      );

      if (update) {
        return new CommonResponseModel(true, 1, " Update Successfully");
      } else {
        return new CommonResponseModel(false, 0, " Something Went Wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error Occurred ", error);
    }
  }

  async getCentricCoLine(req?: SkechersCoLineRequest): Promise<CommonResponseModel> {
    const data = await this.skechersCoLineRepo.getCentricCoLineData(req)
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async deleteCoLine(req: SkechersItemNoDtos): Promise<CommonResponseModel> {
    try {
      const itemToDelete = await this.skechersCoLineRepo.findOne({ where: { id: Number(req.id) } });
      if (!itemToDelete) {
        return new CommonResponseModel(false, 0, "Item No not found", []);
      }
      if (itemToDelete.status === "Success") {
        itemToDelete.isActive = Boolean(0);
        await this.skechersCoLineRepo.save(itemToDelete);
        return new CommonResponseModel(true, 1, "Deleted Successfully");
      } else {
        const deleteResult = await this.skechersCoLineRepo.delete({ id: Number(req.id) });
        if (deleteResult && deleteResult.affected) {
          return new CommonResponseModel(true, 1, "Deleted Successfully");
        } else {
          return new CommonResponseModel(false, 0, "Something Went Wrong", []);
        }
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting or updating ItemNo status", error);
    }
  }

  async updateStatusInOrder(req: any): Promise<CommonResponseModel> {
    try {
      await this.skechersOrdersRepo.update(
        { poNumber: req.poNumber, poStyle: req.poStyle },
        { status: StatusEnum.OPEN }
      );
      return new CommonResponseModel(true, 1, " Updated Successfully");
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error Occurred", error);
    }
  }


  async updateCOLineStatus(req: any): Promise<CommonResponseModel> {
    console.log(req, "updateColinereq")
    const update = await this.skechersOrdersRepo.update(
      { poNumber: req.poNumber }, {
      status: req.status
    })
    if (update.affected) {
      return new CommonResponseModel(true, 1, 'Success')
    } else {
      return new CommonResponseModel(false, 0, 'Failed')
    }
  }

  @Cron('1 * * * *')
  async skechersPdfBot() {
    const browser = await puppeteer.launch({
      headless: false,
      args: ['--start-maximized'],
      executablePath: 'C:\\Program Files (x86)\\Microsoft\\Edge\\Application\\msedge.exe'
    });
    try {
      const page = await browser.newPage();
      await page.setViewport({ width: 1580, height: 900 });

      await page.goto('http://165.22.220.143/sketchers_app/#/login', {
        timeout: 100000,
        waitUntil: 'networkidle0',
      });

      await page.waitForSelector('#login-form_username');
      await page.type('#login-form_username', 'skechers@shahi.co');

      await page.waitForSelector('#login-form_password');
      await page.type('#login-form_password', 'skechers');

      await page.waitForTimeout(2000);
      await page.click('button.ant-btn-primary');

      await page.goto('http://165.22.220.143/sketchers_app/#/skechers/skechers-pdf-upload', {
        timeout: 100000,
        waitUntil: 'networkidle0'
      });

      const directoryPath = 'D:/SKECHERS-POs/NewPos/';
      const destinationDirectory = 'D:/SKECHERS-POs/ReadPos/';

      await page.waitForTimeout(4000);
      const files = fs.readdirSync(directoryPath);

      for (const file of files) {
        await page.waitForTimeout(3000);
        await page.waitForSelector('input[type="file"]');
        const fileInput = await page.$('input[type="file"]');
        const filePath = path.join(directoryPath, file);
        await fileInput.uploadFile(filePath);
        await page.waitForTimeout(3000);

        await page.waitForSelector('button.ant-btn-primary');
        await page.click('button.ant-btn-primary');

        const response = await page.waitForResponse(response => {
          const contentType = response.headers()['content-type'];
          return contentType && contentType.includes('application/json') && response.ok();
        }, { timeout: 0 });

        if (response.ok()) {
          await page.waitForTimeout(3000);
          const sourceFilePath = path.join(directoryPath, file);
          const destinationFilePath = path.join(destinationDirectory, file);

          try {
            fs.renameSync(sourceFilePath, destinationFilePath);
          } catch (err) {
            console.error(`Error moving file: ${file}`, err);
            return new CommonResponseModel(false, 0, 'File move error');
          }
        }
      }
    } catch (error) {
      console.error('Error during process', error);
      return new CommonResponseModel(false, 0, error);
    } finally {
      if (browser) {
        await browser.close();
      }
    }
  }

  async getOrderdataForCOline(req: SKechersOrderDetailsReq): Promise<CommonResponseModel> {
    try {

      const ordersData = await this.skechersOrdersRepo.find({ where: { poNumber: req.poNumber, poStyle: req.poStyle, deliveryAddress: req.deliveryAddress } });

      const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: string }[]>>>();
      const poMap = new Map<string, SkechersOrdersEntity>();

      for (const order of ordersData) {
        poMap.set(`${order.poNumber}`, order);
        console.log(order, 'orderorder')
        const parts = order.deliveryAddress.split(',');
        console.log(parts, "partsparts")
        const dest = parts[2]?.trim() || parts[1]?.trim() || order.deliveryAddress;
        console.log(dest, "destdest")

        if (!destinationColSizesMap.has(`${order.poNumber}`)) {
          destinationColSizesMap.set(`${order.poNumber}`, new Map<string, Map<string, { size: string, quantity: string, }[]>>());
        }

        if (!destinationColSizesMap.get(`${order.poNumber}`).has(dest)) {
          destinationColSizesMap.get(`${order.poNumber}`).set(dest, new Map<string, { size: string, quantity: string, }[]>());
        }

        const editedColode = order.color.replace(/\n/, " ")
        const check = await this.colorRepo.findOne({ where: { poColorName: editedColode } })
        console.log(check, "cccccccccccccc")
        const color = check ? check.crmColorName : editedColode;
        console.log(color, "ccccc//877cccccc")

        if (!destinationColSizesMap.get(order.poNumber).get(dest).has(color)) {
          destinationColSizesMap.get(order.poNumber).get(dest).set(color, []);
        }

        const sizecheck = await this.sizeRepo.find({ where: { poSize: order.size }, });
        // const sizecheckData = sizecheck.length > 0 ? sizecheck[0].crmSize : order.size;
        const sizecheckData = sizecheck.length > 0 ? sizecheck.map(s => s.crmSize).join(', ') : order.size;
        const sizesMap = destinationColSizesMap.get(order.poNumber).get(dest).get(color);

        if (sizecheckData) {
          const existingSize = sizesMap.find((sizeObj) => sizeObj.size === sizecheckData);
          if (existingSize) {
            existingSize.quantity = (parseInt(existingSize.quantity.replace(/,/g, '')) + parseInt(order.quantity.replace(/,/g, ''))).toString();
          } else {
            sizesMap.push({ size: sizecheckData, quantity: order.quantity });
          }
        }

      }

      const coData = [];

      destinationColSizesMap.forEach((destColorSize, poNumber) => {
        const desArray = [];

        destColorSize.forEach((colorSizes, dest) => {
          const ColArray = [];

          colorSizes.forEach((sizes, color) => {
            const sizeArray = sizes.map(size => new SkechersSizeModel(size.size, size.quantity));
            const col = new SkechersColorModel(color, sizeArray);
            ColArray.push(col);
          });

          const des = new SkechersDestinationModel(dest, ColArray);
          desArray.push(des);
        });

        const poInfo = poMap.get(poNumber);
        const co = new SkechersCoLinereqModel(poInfo.poNumber, poInfo.poStyle, poInfo.deliveryDate, poInfo.exFactoryDate, desArray);
        coData.push(co);
      });

      if (coData.length > 0) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', coData);
      } else {
        return new CommonResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      console.error(err);
      throw new Error('Error retrieving data');
    }
  }

  @Cron('*/5 * * * *')
  async createCOline(req: any): Promise<CommonResponseModel> {
    const po = await this.skechersCoLineRepo.getDataforCOLineCreation();
    if (!po) {
      return new CommonResponseModel(false, 0, 'No CO-Line creation requests')
    }
    let driver = await new Builder().forBrowser(Browser.CHROME).build();
    try {
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447#');
      await driver.findElement(By.id('username')).sendKeys('99901347');
      await driver.findElement(By.id('password')).sendKeys('99901347');
      await driver.findElement(By.css('button.btn-primary')).click();
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447')
      const newPAge = await driver.executeScript(
        `javascript:openAccessPage('http://intranet.shahi.co.in:8080/IntraNet/CRMPRDNEW.jsp', 'CRM', '2448', 'R', '99901347', 'N', '20634576', 'null');`
      );
      const windowHandles = await driver.getAllWindowHandles()
      await driver.switchTo().window(windowHandles[1]);
      const frame = await driver.findElement(By.id('mainFrame'));
      await driver.switchTo().frame(frame)
      console.log(po, "pppppppppppppppppp")
      const coLine = new SkechersCoLineRequestApi();
      let buyerValue1;
      let buyerValue2;
      let agent;
      let buyerAddress;
      let deliveryAddress;
      let pkgTerms;
      let paymentMethod;
      let paymentTerms;
      let poStyle;
      const update = await this.skechersCoLineRepo.update({ poNumber: po.po_number, poStyle: po.po_style, itemNo: po.item_no }, { status: 'Inprogress' });
      const response = await this.getOrderdataForCOline({ poNumber: po.po_number, poStyle: po.po_style })
      console.log("hahhhh")
      // console.log(response, "hello")
      // console.log(response.data[0], "response")
      const coData = response.data[0];
      console.log(coData, "coDatacoDatacoData")
      coLine.poNumber = coData.poNumber
      coLine.exFactoryDate = coData.exFactoryDate
      coLine.deliveryDate = coData.deliveryDate
      coLine.destinations = coData.destinations
      // console.log(coLine.destinations, "destinationsdestinationsdestinations")
      console.log(coLine, "colijeneneen")
      console.log(coLine.exFactoryDate, "coLine.exFactoryDate")
      console.log(coLine.deliveryDate, "coLine.deliveryDate")
      const request = coData.destinations[0]?.name;
      // console.log(coData.destinations[0]?.name,"coData.destinations[0]?.name")
      const address = await this.getAddressInfoByCountry({ country: request });
      // console.log(address, "dhdhdhdhddhdh")
      const addressData = address.data;
      // console.log(addressData, "addressData")
      console.log("----------------start----------------")

      if (!addressData) {
        const update = await this.skechersCoLineRepo.update(
          { poNumber: po.po_number, poStyle: po.po_style },
          { status: "Failed", errorMsg: "Address Not Matching", isActive: false }
        );
        await this.updateCOLineStatus({ poNumber: po.po_number, status: StatusEnum.FAILED });
        return new CommonResponseModel(false, 0, "Address Not Matching");
      }
      poStyle = coData.poStyle
      buyerAddress = addressData?.buyerCode
      deliveryAddress = addressData?.deliveryCode
      buyerValue1 = "DEF-OTHERS"
      buyerValue2 = "SKE00005-SKECHERS USA INC"
      agent = "-NA"
      pkgTerms = "FP1-WITHOUT HANGER"
      paymentMethod = "TTE-Telegraphic Transfer"
      paymentTerms = "030-Trde Card30 Day"

      const apps = await driver.wait(until.elementLocated(By.xpath('//*[@id="mainContainer"]/div[1]')));
      const allApps = await apps.findElements(By.tagName('span'));
      for (const app of allApps) {
        if ((await app.getAttribute('innerText')).includes('Style Orders')) {
          await driver.executeScript('arguments[0].click();', app);
          break;
        }
      }

      await driver.sleep(10000)
      await driver.wait(until.elementLocated(By.id('styleid2H')))
      await driver.findElement(By.id('styleid2H')).sendKeys(po.item_no);
      await driver.sleep(5000)
      await driver.wait(until.elementLocated(By.id('bgpset1')));
      const dropdownElement1 = await driver.findElement(By.id('bgpset1'));
      const dropdown1 = await driver.wait(until.elementIsVisible(dropdownElement1)).then(element => new Select(element))
      await dropdown1.selectByValue(buyerValue1)
      await driver.sleep(5000)
      await driver.wait(until.elementLocated(By.id('byr')));
      const dropdownElement2 = await driver.findElement(By.id('byr'));
      const dropdown2 = await driver.wait(until.elementIsVisible(dropdownElement2)).then(element => new Select(element))
      await dropdown2.selectByValue(buyerValue2)
      await driver.sleep(3000)
      await driver.wait(until.elementLocated(By.id('CreateOrderID')))
      await driver.sleep(5000)
      await driver.findElement(By.id('CreateOrderID')).click();
      try {
        const errorElemetOne = await driver.wait(until.elementLocated(By.xpath('//*[@id="form1bgb"]/table/tbody/tr[2]/td/table/tbody/tr[1]/td/ul/li/span')), 5000);
        await driver.sleep(1000)
        const skuVariantsItem = await errorElemetOne.getText();
        await driver.sleep(1000)
        console.log(skuVariantsItem, "skuVariantsItem")
        if (skuVariantsItem.includes("All Item SKU Variants are in status 90.")) {
          const update = await this.skechersCoLineRepo.update({ poNumber: po.po_number, poStyle: po.po_style, itemNo: po.item_no }, { status: 'Failed', errorMsg: `All Item SKU Variants are in status 90.`, isActive: false });
          await this.updateCOLineStatus({ poNumber: po.po_number, status: StatusEnum.FAILED })
          return new CommonResponseModel(false, 0, "All Item SKU Variants are in status 90.", skuVariantsItem)
        }
      } catch (err) {
        console.log("Starting Catch Error", err);
      }
      console.log("SKU Data not found, Proceeding to the next steps")
      await driver.wait(until.elementLocated(By.id('bpo')))
      await driver.findElement(By.id('bpo')).clear();
      await driver.findElement(By.id('bpo')).sendKeys(coLine.poNumber);

      await driver.wait(until.elementLocated(By.id('bus')))
      await driver.findElement(By.id('bus')).clear();
      await driver.findElement(By.id('bus')).sendKeys(poStyle);

      await driver.wait(until.elementLocated(By.id('agnt')));
      const agentDropDown = await driver.findElement(By.id('agnt'));
      await driver.executeScript(`arguments[0].value = '${agent}';`, agentDropDown)

      await driver.wait(until.elementLocated(By.name('dojo.EXFACTORYDATE')));
      await driver.findElement(By.name('dojo.EXFACTORYDATE')).clear();
      await driver.findElement(By.name('dojo.EXFACTORYDATE')).sendKeys(coLine.exFactoryDate);

      await driver.wait(until.elementLocated(By.name('dojo.delydt')));
      await driver.findElement(By.name('dojo.delydt')).clear();
      await driver.findElement(By.name('dojo.delydt')).sendKeys(coLine.deliveryDate);

      await driver.wait(until.elementLocated(By.name('byd')));
      const dropdown = await driver.findElement(By.name('byd'));
      const options = await dropdown.findElements(By.tagName('option'));
      const optionValues = [];
      for (const option of options) {
        const value = await option.getAttribute('value');
        optionValues.push(value);
      }
      const number = optionValues.find(value => {
        return Number(value.split('-')[0].trim()) == Number(buyerAddress)
      });
      await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);

      await driver.wait(until.elementLocated(By.xpath('//*[@id="price"]')));
      await driver.findElement(By.xpath('//*[@id="price"]')).clear();
      await driver.findElement(By.xpath('//*[@id="price"]')).sendKeys(po.price);

      await driver.wait(until.elementLocated(By.id('packtrm')));
      const pkgTermsDropDown = await driver.findElement(By.id('packtrm'));
      await driver.executeScript(`arguments[0].value = '${pkgTerms}';`, pkgTermsDropDown)

      await driver.wait(until.elementLocated(By.id('pmt')));
      const ptmDropDown = await driver.findElement(By.id('pmt'));
      await driver.executeScript(`arguments[0].value = '${paymentMethod}';`, ptmDropDown)

      await driver.wait(until.elementLocated(By.id('ptr')));
      const ptrDropDown = await driver.findElement(By.id('ptr'));
      await driver.executeScript(`arguments[0].value = '${paymentTerms}';`, ptrDropDown)
      await driver.sleep(10000)

      for (let dest of coLine.destinations) {
        const colorsContainer = await driver.wait(until.elementLocated(By.xpath('//*[@id="COContainer"]')));
        const colorsTabs = await colorsContainer.findElements(By.tagName('span'));
        for (const tab of colorsTabs) {
          if ((await tab.getAttribute('innerText')) == dest.name) {
            await driver.executeScript('arguments[0].click();', tab);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                if (colorIndex === 0) {
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1;
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => value.includes(deliveryAddress));
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString();
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  // const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  // if (inputField) {
                  //   await inputField.clear();
                  //   await inputField.sendKeys(size.price);
                  //   // await inputField.sendKeys("0");
                  // }
                }
                const inputId = `${size.name}:${color.name}:${dest.name}`.replace(/\*/g, '');
                const input = await driver.wait(until.elementLocated(By.id(inputId)))
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
            await driver.executeScript('arguments[0].click();', tab);
            const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
            const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;

            // parent div ids
            /**
             * to read sizes : nameDiv1359QZD001
             * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
             * to read input fields: percentageDiv1359QZD001
             * 
             */
            const allSizes = [];
            console.log('---------------------------------------------------------------');
            await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
            // console.log("Read");

            // -----------------------   SIZES Reading from UI logic start ---------------
            // read all the sizes from the DOM
            let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
            const totalElements = labelElements?.length;
            console.log('Total elements : ' + totalElements);
            labelElements.forEach(async r => {
              const label = (await r.getText()).trim().toUpperCase().toString();
              allSizes.push(label);
            });
            // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
            let i = 1;
            while (i <= 10) {
              // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
              const toJump = Math.min(i * 8, totalElements);
              const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
              // scroll the pointer to right side
              driver.executeScript("arguments[0].scrollIntoView()", rightEle);
              driver.sleep(1000);
              // read all the visible sizes from the DOM
              let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
              // console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
              currentUserVisbileElements.forEach(async (r, index) => {
                if (allSizes[index] == '') {
                  // console.log(index, "index");
                  const label = (await r.getText()).trim().toUpperCase().toString();
                  allSizes[index] = label;
                }
              });
              // console.log(allSizes);
              i++;
            }
            // construct a reverse mapping of size => column location for easy scrolling during qty input
            const sizeToDisplayRowColumnIndex = [];
            allSizes.forEach((size, i) => {
              sizeToDisplayRowColumnIndex[size] = i;
            })
            // -----------------------   SIZES Reading from UI logic END ---------------

            // ---------------------- COLOR GETTING LOGIC START -------------------------
            const colorsInTable = [];
            const colorsToDisplayRowColumnIndex = [];
            // get the total colors for the current PO from the UI
            const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
            console.log('total colors : ' + totalColorElements.length);
            let cc = 0;
            for (const r of totalColorElements) {
              // console.log("plesessssssssssssssssss")
              // scroll to the specific location in the screen to read the color 
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
              // execute the scroll command
              await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              await driver.sleep(500);
              // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
              const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
              const displayingColor = (await sepcificRowColorEle[0]?.getText());
              // push the color to an array
              colorsInTable.push(displayingColor);
              cc++;
            }

            // now reverse map the color -> exact row index in the DOM
            colorsInTable.forEach((color, index) => {
              colorsToDisplayRowColumnIndex[color] = index;
            });
            // ---------------------- COLOR GETTING LOGIC END -------------------------

            //  console.log("ppppppppppppppp")
            console.log(dest.colors, "dest.colors")
            for (let [colorIndex, color] of dest.colors.entries()) {
              // for this specific color, scroll the window to the specific row where the color is visible
              console.log(color.name, "color.name")
              const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[color.name] + 1;
              if (colorsToDisplayRowColumnIndex[color.name] == undefined || colorsToDisplayRowColumnIndex[color.name] == null) {
                const update = await this.skechersCoLineRepo.update({ poNumber: po.po_number, poStyle: po.po_style, itemNo: po.item_no }, { status: 'Failed', errorMsg: `NO matching Color found`, isActive: false });
                await this.updateCOLineStatus({ poNumber: po.po_number, status: StatusEnum.FAILED })
                return new CommonResponseModel(false, 0, 'Matching Color not found')
              }
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
              driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              driver.sleep(500);
              for (let [sizeIndex, size] of color.sizes.entries()) {
                const normalizedSizeToDisplayRowColumnIndex = {};
                for (const [key, value] of Object.entries(sizeToDisplayRowColumnIndex)) {
                  normalizedSizeToDisplayRowColumnIndex[key.toUpperCase()] = value;
                }

                const sizeVariants = size.name.split(',').map(s => s.trim().toUpperCase());
                console.log("sizeVariants:", sizeVariants);
                console.log("normalizedSizeToDisplayRowColumnIndex:", Object.keys(normalizedSizeToDisplayRowColumnIndex));

                let matchedSizeColumnScrollLocation = null;

                for (const sizesData of sizeVariants) {
                  console.log(`Checking if ${sizesData} exists in sizeToDisplayRowColumnIndex...`);
                  if (sizesData in normalizedSizeToDisplayRowColumnIndex) {
                    matchedSizeColumnScrollLocation = normalizedSizeToDisplayRowColumnIndex[sizesData] + 1; 
                    console.log(`Matched Size: ${sizesData}`);
                    break;
                  }
                }

                if (!matchedSizeColumnScrollLocation) {
                  await this.skechersCoLineRepo.update(
                    { poNumber: po.po_number, poStyle: po.po_style, itemNo: po.item_no },
                    { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false }
                  );
                  await this.updateCOLineStatus({ poNumber: po.po_number, status: StatusEnum.FAILED });
                  return new CommonResponseModel(false, 0, 'NO matching Size found');
                }
                const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${matchedSizeColumnScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(300);
                // Find all the labels in the second row.
                await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                const fileteredElements: any[] = [];
                for (const labelElement of labelElements) {
                  const ele = (await labelElement.getText())?.trim();
                  ele.length > 0 ? fileteredElements.push(labelElement) : '';
                }
                let tabIndex = 1;
                const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                const options = await dropdown.findElements(By.tagName('option'));
                const optionValues = [];
                for (const option of options) {
                  const value = await option.getAttribute('value');
                  optionValues.push(value);
                }
                const number = optionValues.find(value => {
                  return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                });
                console.log(number, "nummmm")
                // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                // Find all the input fields in the first row.
                const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                // Create a map of size labels to input fields.
                const sizeToInputMap = {};
                allSizes.forEach((s, index) => {
                  sizeToInputMap[s] = inputElements[index];
                });
                // console.log('----------------------Size map done --------------------------');
                // console.log(sizeToInputMap, "sizeToInputMap")
                const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                if (inputField) {
                  // // Clear the existing value (if any) and fill it with the new price.
                  // await inputField.clear();
                  // await inputField.sendKeys(size.price);
                } else {
                  const update = await this.skechersCoLineRepo.update({ poNumber: po.po_number, poStyle: po.po_style, itemNo: po.item_no }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                  await this.updateCOLineStatus({ poNumber: po.po_number, status: StatusEnum.FAILED })
                  return new CommonResponseModel(false, 0, 'NO matching Size found')
                }
                const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
                console.log(inputId, "inputId")
                const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
        }
      }

      await driver.sleep(10000)
      const element = await driver.findElement(By.id('OrderCreateID')).click();
      await driver.wait(until.alertIsPresent(), 10000);
      const alert = await driver.switchTo().alert();
      await alert.accept();
      if (await this.isAlertPresent(driver)) {
        const alert = await driver.switchTo().alert();
        const alertText = await alert.getText();
        const update = await this.skechersCoLineRepo.update(
          { poNumber: po.po_number, poStyle: po.po_style },
          { status: "Failed", errorMsg: alertText, isActive: false }
        );
        await this.updateCOLineStatus({ poNumber: po.po_number, status: StatusEnum.FAILED });
        await alert.accept();
        await driver.sleep(5000)
        await driver.navigate().refresh();
        return new CommonResponseModel(false, 0, alertText)
      }
      else {
        await driver.sleep(10000)
        await driver.wait(until.elementLocated(By.xpath('//*[@id="orno"]')), 10000);
        const coNoElement = await driver.findElement(By.xpath('//*[@id="orno"]'));
        const coNo = await coNoElement.getAttribute('value');
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(currentDate);
        const year = currentDate.getFullYear().toString().slice(-2);
        const currentDateFormatted = `${day}-${month}-${year}`;
        if (coNo) {
          await this.skechersCoLineRepo.update(
            { poNumber: po.po_number, poStyle: po.po_style },
            { coDate: currentDateFormatted, coNumber: coNo, status: 'Success', errorMsg: '-' }
          );
          await this.updateCOLineStatus({ poNumber: po.po_number, status: StatusEnum.SUCCESS })
          await driver.sleep(5000)
          return new CommonResponseModel(true, 1, "COline created successfully");
        } else {
          const update = await this.skechersCoLineRepo.update({ poNumber: po.po_number, poStyle: po.po_style,errorMsg:"CO Number Not Find" }, { status: 'Failed', isActive: false });
          await this.updateCOLineStatus({ poNumber: po.po_number, status: StatusEnum.FAILED })
          await driver.sleep(3000)
        }
      }
      return new CommonResponseModel(true, 1, `COline created successfully`)
    } catch (err) {
      console.log(err, 'error');
      const update = await this.skechersCoLineRepo.update({ poNumber: po.po_number, poStyle: po.po_style }, { status: 'Failed', errorMsg: err.message, isActive: false });
      await this.updateCOLineStatus({ poNumber: po.po_number, status: StatusEnum.FAILED })
      return new CommonResponseModel(false, 0, err.message)
    }
    finally {
      driver.quit()
    }
  }

  async isAlertPresent(driver) {
    try {
      await driver.switchTo().alert();
      return true;
    } catch (e) {
      return false;
    }
  }



}